// src/pages/AboutPage.js
import React from 'react';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page-container">
      {/* === REACT 19 SEO TAGS (No change needed here) === */}
      <title>About DiscoverSupps - Your Smart Amazon Supplement Search Tool</title>
      <meta 
        name="description" 
        content="Learn about DiscoverSupps.com and our mission to help you find the best supplements on Amazon through precise, powerful filtering." 
      />
      <meta property="og:title" content="About DiscoverSupps" />
      <meta property="og:url" content="https://discoversupps.com/about" />
      <meta property="og:description" content="Learn how DiscoverSupps helps you find the perfect supplements on Amazon using advanced filtering by ingredients, health goals, and dietary restrictions." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://discoversupps.com/logo512.png" />

    {/* Add structured data for the About page */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "About DiscoverSupps",
            "description": "Learn about our mission to help you find the best supplements on Amazon",
            "url": "https://discoversupps.com/about",
            "mainEntity": {
                "@type": "WebApplication",
                "name": "DiscoverSupps",
                "url": "https://discoversupps.com"
            }
        })}
    </script>
    {/* === END OF SEO TAGS === */}

      <div className="about-section">
        <h2>Our Mission</h2>
        <p>
          The world of supplements can be overwhelming. Confusing labels, endless options, and biased reviews make it difficult to find products that genuinely align with your health goals and dietary needs.
        </p>
        <p>
          <strong>DiscoverSupps was created to cut through the noise.</strong> Our mission is to provide a powerful, intuitive, and user-focused tool that empowers you to find the perfect supplements on Amazon with confidence and ease. We believe that finding the right product shouldn't be a chore.
        </p>

        {/* --- NEW PARAGRAPH ADDED HERE --- */}
        <p>
          Our database is a carefully curated and continuously growing collection. Because each supplement is reviewed before being added, this process takes time. If there's a product you love that you can't find here, we want to hear about it! Please feel free to reach out to us on{' '}
          <a href="https://x.com/DiscoverSupps" target="_blank" rel="noopener noreferrer">X (formerly Twitter)</a>
          {' '}to suggest an addition.
        </p>
        {/* --- END OF NEW PARAGRAPH --- */}

      </div>

      <div className="about-section">
        <h3>How It Works</h3>
        <p>We've focused on creating a simple, three-step process for discovery:</p>
        <ol>
          <li><strong>Filter with Precision:</strong> Use our comprehensive filters to narrow down your search. Select your health goals, specific ingredients, dietary requirements (like vegan or gluten-free), and preferred supplement types (if needed).</li>
          <li><strong>Discover Your Options:</strong> Our system instantly queries our curated database to show you products that match your exact criteria.</li>
          <li><strong>Make an Informed Choice:</strong> Click on any supplement to be taken directly to its Amazon page, where you can view pricing, read user reviews, and make your purchase.</li>
        </ol>
      </div>

      <div className="about-section">
        <h3>Our Philosophy</h3>
        <p>
          <strong>Simplicity and Power:</strong> We are committed to a clean, ad-free experience. Our focus is solely on providing the best filtering tool possible, without distractions.
        </p>
        <p>
          <strong>Transparency:</strong> We believe in being upfront with our users. To support our work and keep this tool free, we participate in the Amazon Associates program.
        </p>

        <div className="disclaimer-box">
          <h3>Affiliate Disclosure</h3>
          <p>
            DiscoverSupps is a participant in the Amazon Services LLC Associates Program, an affiliate advertising program designed to provide a means for sites to earn advertising fees by advertising and linking to Amazon.com. When you click on a link and make a purchase, we may receive a small commission at no extra cost to you. This support helps us maintain and improve the website.
          </p>
        </div>
      </div>

      <div className="about-section">
        <div className="disclaimer-box">
            <h3>Important Medical Disclaimer</h3>
            <p>
                The content provided on DiscoverSupps.com is for informational purposes only and is not intended as a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
            </p>
        </div>
      </div>

    </div>
  );
};

export default AboutPage;
